"use strict";

module.exports = [{
  "id": 1200,
  "description": "Accounting",
  "subClassifications": [{
    "id": 6140,
    "description": "Accounts Officers/Clerks"
  }, {
    "id": 1303,
    "description": "Accounts Payable"
  }, {
    "id": 6141,
    "description": "Accounts Receivable/Credit Control"
  }, {
    "id": 6143,
    "description": "Analysis & Reporting"
  }, {
    "id": 6142,
    "description": "Assistant Accountants"
  }, {
    "id": 6144,
    "description": "Audit - External"
  }, {
    "id": 6145,
    "description": "Audit - Internal"
  }, {
    "id": 6146,
    "description": "Bookkeeping & Small Practice Accounting"
  }, {
    "id": 6147,
    "description": "Business Services & Corporate Advisory"
  }, {
    "id": 6148,
    "description": "Company Secretaries"
  }, {
    "id": 6149,
    "description": "Compliance & Risk"
  }, {
    "id": 6150,
    "description": "Cost Accounting"
  }, {
    "id": 6151,
    "description": "Financial Accounting & Reporting"
  }, {
    "id": 6152,
    "description": "Financial Managers & Controllers"
  }, {
    "id": 6153,
    "description": "Forensic Accounting & Investigation"
  }, {
    "id": 6154,
    "description": "Insolvency & Corporate Recovery"
  }, {
    "id": 6155,
    "description": "Inventory & Fixed Assets"
  }, {
    "id": 6156,
    "description": "Management"
  }, {
    "id": 6157,
    "description": "Management Accounting & Budgeting"
  }, {
    "id": 1468,
    "description": "Payroll"
  }, {
    "id": 6158,
    "description": "Strategy & Planning"
  }, {
    "id": 6159,
    "description": "Systems Accounting & IT Audit"
  }, {
    "id": 6160,
    "description": "Taxation"
  }, {
    "id": 6161,
    "description": "Treasury"
  }, {
    "id": 6162,
    "description": "Other"
  }]
}, {
  "id": 6251,
  "description": "Administration & Office Support",
  "subClassifications": [{
    "id": 6252,
    "description": "Administrative Assistants"
  }, {
    "id": 6253,
    "description": "Client & Sales Administration"
  }, {
    "id": 6254,
    "description": "Contracts Administration"
  }, {
    "id": 6255,
    "description": "Data Entry & Word Processing"
  }, {
    "id": 6256,
    "description": "Office Management"
  }, {
    "id": 6257,
    "description": "PA, EA & Secretarial"
  }, {
    "id": 6258,
    "description": "Receptionists"
  }, {
    "id": 6259,
    "description": "Records Management & Document Control"
  }, {
    "id": 6260,
    "description": "Other"
  }]
}, {
  "id": 6304,
  "description": "Advertising, Arts & Media",
  "subClassifications": [{
    "id": 6305,
    "description": "Agency Account Management"
  }, {
    "id": 6306,
    "description": "Art Direction"
  }, {
    "id": 6307,
    "description": "Editing & Publishing"
  }, {
    "id": 6308,
    "description": "Event Management"
  }, {
    "id": 6309,
    "description": "Journalism & Writing"
  }, {
    "id": 6310,
    "description": "Management"
  }, {
    "id": 6311,
    "description": "Media Strategy, Planning & Buying"
  }, {
    "id": 6312,
    "description": "Performing Arts"
  }, {
    "id": 6313,
    "description": "Photography"
  }, {
    "id": 6314,
    "description": "Programming & Production"
  }, {
    "id": 6315,
    "description": "Promotions"
  }, {
    "id": 6316,
    "description": "Other"
  }]
}, {
  "id": 1203,
  "description": "Banking & Financial Services",
  "subClassifications": [{
    "id": 6174,
    "description": "Account & Relationship Management"
  }, {
    "id": 6175,
    "description": "Analysis & Reporting"
  }, {
    "id": 6177,
    "description": "Banking - Business"
  }, {
    "id": 6178,
    "description": "Banking - Corporate & Institutional"
  }, {
    "id": 6176,
    "description": "Banking - Retail/Branch"
  }, {
    "id": 1352,
    "description": "Client Services"
  }, {
    "id": 6179,
    "description": "Compliance & Risk"
  }, {
    "id": 6180,
    "description": "Corporate Finance & Investment Banking"
  }, {
    "id": 6181,
    "description": "Credit"
  }, {
    "id": 1392,
    "description": "Financial Planning"
  }, {
    "id": 1404,
    "description": "Funds Management"
  }, {
    "id": 6182,
    "description": "Management"
  }, {
    "id": 6183,
    "description": "Mortgages"
  }, {
    "id": 6184,
    "description": "Settlements"
  }, {
    "id": 6185,
    "description": "Stockbroking & Trading"
  }, {
    "id": 6186,
    "description": "Treasury"
  }, {
    "id": 6187,
    "description": "Other"
  }]
}, {
  "id": 1204,
  "description": "Call Centre & Customer Service",
  "subClassifications": [{
    "id": 6084,
    "description": "Collections"
  }, {
    "id": 6085,
    "description": "Customer Service - Call Centre"
  }, {
    "id": 6086,
    "description": "Customer Service - Customer Facing"
  }, {
    "id": 6087,
    "description": "Management & Support"
  }, {
    "id": 6088,
    "description": "Sales - Inbound"
  }, {
    "id": 6089,
    "description": "Sales - Outbound"
  }, {
    "id": 6090,
    "description": "Supervisors/Team Leaders"
  }, {
    "id": 6091,
    "description": "Other"
  }]
}, {
  "id": 7019,
  "description": "CEO & General Management",
  "subClassifications": [{
    "id": 7020,
    "description": "Board Appointments"
  }, {
    "id": 7021,
    "description": "CEO"
  }, {
    "id": 7022,
    "description": "COO & MD"
  }, {
    "id": 7023,
    "description": "General/Business Unit Manager"
  }, {
    "id": 7024,
    "description": "Other"
  }]
}, {
  "id": 6163,
  "description": "Community Services & Development",
  "subClassifications": [{
    "id": 6164,
    "description": "Aged & Disability Support"
  }, {
    "id": 6165,
    "description": "Child Welfare, Youth & Family Services"
  }, {
    "id": 6166,
    "description": "Community Development"
  }, {
    "id": 6167,
    "description": "Employment Services"
  }, {
    "id": 6168,
    "description": "Fundraising"
  }, {
    "id": 6169,
    "description": "Housing & Homelessness Services"
  }, {
    "id": 6170,
    "description": "Indigenous & Multicultural Services"
  }, {
    "id": 6171,
    "description": "Management"
  }, {
    "id": 6172,
    "description": "Volunteer Coordination & Support"
  }, {
    "id": 6173,
    "description": "Other"
  }]
}, {
  "id": 1206,
  "description": "Construction",
  "subClassifications": [{
    "id": 6113,
    "description": "Contracts Management"
  }, {
    "id": 1387,
    "description": "Estimating"
  }, {
    "id": 6114,
    "description": "Foreperson/Supervisors"
  }, {
    "id": 6115,
    "description": "Health, Safety & Environment"
  }, {
    "id": 6116,
    "description": "Management"
  }, {
    "id": 6117,
    "description": "Planning & Scheduling"
  }, {
    "id": 6118,
    "description": "Plant & Machinery Operators"
  }, {
    "id": 6119,
    "description": "Project Management"
  }, {
    "id": 6120,
    "description": "Quality Assurance & Control"
  }, {
    "id": 6121,
    "description": "Surveying"
  }, {
    "id": 6122,
    "description": "Other"
  }]
}, {
  "id": 6076,
  "description": "Consulting & Strategy",
  "subClassifications": [{
    "id": 6077,
    "description": "Analysts"
  }, {
    "id": 6078,
    "description": "Corporate Development"
  }, {
    "id": 6079,
    "description": "Environment & Sustainability Consulting"
  }, {
    "id": 6080,
    "description": "Management & Change Consulting"
  }, {
    "id": 6081,
    "description": "Policy"
  }, {
    "id": 6082,
    "description": "Strategy & Planning"
  }, {
    "id": 6083,
    "description": "Other"
  }]
}, {
  "id": 6263,
  "description": "Design & Architecture",
  "subClassifications": [{
    "id": 6265,
    "description": "Architectural Drafting"
  }, {
    "id": 6264,
    "description": "Architecture"
  }, {
    "id": 6267,
    "description": "Fashion & Textile Design"
  }, {
    "id": 6268,
    "description": "Graphic Design"
  }, {
    "id": 6266,
    "description": "Illustration & Animation"
  }, {
    "id": 6269,
    "description": "Industrial Design"
  }, {
    "id": 6270,
    "description": "Interior Design"
  }, {
    "id": 6271,
    "description": "Landscape Architecture"
  }, {
    "id": 6272,
    "description": "Urban Design & Planning"
  }, {
    "id": 6273,
    "description": "Web & Interaction Design"
  }, {
    "id": 6274,
    "description": "Other"
  }]
}, {
  "id": 6123,
  "description": "Education & Training",
  "subClassifications": [{
    "id": 6124,
    "description": "Childcare & Outside School Hours Care"
  }, {
    "id": 6125,
    "description": "Library Services & Information Management"
  }, {
    "id": 6126,
    "description": "Management - Schools"
  }, {
    "id": 6127,
    "description": "Management - Universities"
  }, {
    "id": 6128,
    "description": "Management - Vocational"
  }, {
    "id": 6129,
    "description": "Research & Fellowships"
  }, {
    "id": 6130,
    "description": "Student Services"
  }, {
    "id": 6132,
    "description": "Teaching - Early Childhood"
  }, {
    "id": 6133,
    "description": "Teaching - Primary"
  }, {
    "id": 6134,
    "description": "Teaching - Secondary"
  }, {
    "id": 6135,
    "description": "Teaching - Tertiary"
  }, {
    "id": 6136,
    "description": "Teaching - Vocational"
  }, {
    "id": 6131,
    "description": "Teaching Aides & Special Needs"
  }, {
    "id": 6137,
    "description": "Tutoring"
  }, {
    "id": 6138,
    "description": "Workplace Training & Assessment"
  }, {
    "id": 6139,
    "description": "Other"
  }]
}, {
  "id": 1209,
  "description": "Engineering",
  "subClassifications": [{
    "id": 6022,
    "description": "Aerospace Engineering"
  }, {
    "id": 6023,
    "description": "Automotive Engineering"
  }, {
    "id": 6024,
    "description": "Building Services Engineering"
  }, {
    "id": 6026,
    "description": "Chemical Engineering"
  }, {
    "id": 6027,
    "description": "Civil/Structural Engineering"
  }, {
    "id": 6028,
    "description": "Electrical/Electronic Engineering"
  }, {
    "id": 6025,
    "description": "Engineering Drafting"
  }, {
    "id": 6029,
    "description": "Environmental Engineering"
  }, {
    "id": 6030,
    "description": "Field Engineering"
  }, {
    "id": 6031,
    "description": "Industrial Engineering"
  }, {
    "id": 6032,
    "description": "Maintenance"
  }, {
    "id": 6033,
    "description": "Management"
  }, {
    "id": 6034,
    "description": "Materials Handling Engineering"
  }, {
    "id": 6035,
    "description": "Mechanical Engineering"
  }, {
    "id": 6036,
    "description": "Process Engineering"
  }, {
    "id": 6038,
    "description": "Project Engineering"
  }, {
    "id": 6037,
    "description": "Project Management"
  }, {
    "id": 6039,
    "description": "Supervisors"
  }, {
    "id": 6040,
    "description": "Systems Engineering"
  }, {
    "id": 6041,
    "description": "Water & Waste Engineering"
  }, {
    "id": 6042,
    "description": "Other"
  }]
}, {
  "id": 6205,
  "description": "Farming, Animals & Conservation",
  "subClassifications": [{
    "id": 6206,
    "description": "Agronomy & Farm Services"
  }, {
    "id": 6207,
    "description": "Conservation, Parks & Wildlife"
  }, {
    "id": 6208,
    "description": "Farm Labour"
  }, {
    "id": 6209,
    "description": "Farm Management"
  }, {
    "id": 6210,
    "description": "Fishing & Aquaculture"
  }, {
    "id": 6211,
    "description": "Horticulture"
  }, {
    "id": 6212,
    "description": "Veterinary Services & Animal Welfare"
  }, {
    "id": 6213,
    "description": "Winery & Viticulture"
  }, {
    "id": 6214,
    "description": "Other"
  }]
}, {
  "id": 1210,
  "description": "Government & Defence",
  "subClassifications": [{
    "id": 1314,
    "description": "Air Force"
  }, {
    "id": 1322,
    "description": "Army"
  }, {
    "id": 1378,
    "description": "Emergency Services"
  }, {
    "id": 6356,
    "description": "Government"
  }, {
    "id": 1409,
    "description": "Government - Federal"
  }, {
    "id": 1410,
    "description": "Government - Local"
  }, {
    "id": 1411,
    "description": "Government - State"
  }, {
    "id": 6357,
    "description": "Local Government"
  }, {
    "id": 1450,
    "description": "Navy"
  }, {
    "id": 6359,
    "description": "Police & Corrections"
  }, {
    "id": 6360,
    "description": "Policy, Planning & Regulation"
  }, {
    "id": 6358,
    "description": "Regional Council"
  }, {
    "id": 6361,
    "description": "Other"
  }]
}, {
  "id": 1211,
  "description": "Healthcare & Medical",
  "subClassifications": [{
    "id": 6329,
    "description": "Ambulance/Paramedics"
  }, {
    "id": 6330,
    "description": "Chiropractic & Osteopathic"
  }, {
    "id": 1353,
    "description": "Clinical/Medical Research"
  }, {
    "id": 1372,
    "description": "Dental"
  }, {
    "id": 6331,
    "description": "Dieticians"
  }, {
    "id": 1386,
    "description": "Environmental Services"
  }, {
    "id": 6332,
    "description": "General Practitioners"
  }, {
    "id": 6333,
    "description": "Management"
  }, {
    "id": 6334,
    "description": "Medical Administration"
  }, {
    "id": 6335,
    "description": "Medical Imaging"
  }, {
    "id": 6336,
    "description": "Medical Specialists"
  }, {
    "id": 6337,
    "description": "Natural Therapies & Alternative Medicine"
  }, {
    "id": 6338,
    "description": "Nursing - A&E, Critical Care & ICU"
  }, {
    "id": 6339,
    "description": "Nursing - Aged Care"
  }, {
    "id": 6340,
    "description": "Nursing - Community, Maternal & Child Health"
  }, {
    "id": 6341,
    "description": "Nursing - Educators & Facilitators"
  }, {
    "id": 6342,
    "description": "Nursing - General Medical & Surgical"
  }, {
    "id": 6343,
    "description": "Nursing - High Acuity"
  }, {
    "id": 6344,
    "description": "Nursing - Management"
  }, {
    "id": 6345,
    "description": "Nursing - Midwifery, Neo-Natal, SCN & NICU"
  }, {
    "id": 6346,
    "description": "Nursing - Paediatric & PICU"
  }, {
    "id": 6347,
    "description": "Nursing - Psych, Forensic & Correctional Health"
  }, {
    "id": 6348,
    "description": "Nursing - Theatre & Recovery"
  }, {
    "id": 6349,
    "description": "Optical"
  }, {
    "id": 1467,
    "description": "Pathology"
  }, {
    "id": 6350,
    "description": "Pharmaceuticals & Medical Devices"
  }, {
    "id": 1470,
    "description": "Pharmacy"
  }, {
    "id": 6352,
    "description": "Physiotherapy, OT & Rehabilitation"
  }, {
    "id": 6351,
    "description": "Psychology, Counselling & Social Work"
  }, {
    "id": 6370,
    "description": "Residents & Registrars"
  }, {
    "id": 6353,
    "description": "Sales"
  }, {
    "id": 6354,
    "description": "Speech Therapy"
  }, {
    "id": 6355,
    "description": "Other"
  }]
}, {
  "id": 1212,
  "description": "Hospitality & Tourism",
  "subClassifications": [{
    "id": 1315,
    "description": "Airlines"
  }, {
    "id": 1332,
    "description": "Bar & Beverage Staff"
  }, {
    "id": 6052,
    "description": "Chefs/Cooks"
  }, {
    "id": 6053,
    "description": "Front Office & Guest Services"
  }, {
    "id": 1405,
    "description": "Gaming"
  }, {
    "id": 1415,
    "description": "Housekeeping"
  }, {
    "id": 6054,
    "description": "Kitchen & Sandwich Hands"
  }, {
    "id": 6055,
    "description": "Management"
  }, {
    "id": 6056,
    "description": "Reservations"
  }, {
    "id": 1537,
    "description": "Tour Guides"
  }, {
    "id": 1542,
    "description": "Travel Agents/Consultants"
  }, {
    "id": 1549,
    "description": "Waiting Staff"
  }, {
    "id": 6057,
    "description": "Other"
  }]
}, {
  "id": 6317,
  "description": "Human Resources & Recruitment",
  "subClassifications": [{
    "id": 6318,
    "description": "Consulting & Generalist HR"
  }, {
    "id": 6319,
    "description": "Industrial & Employee Relations"
  }, {
    "id": 6320,
    "description": "Management - Agency"
  }, {
    "id": 6321,
    "description": "Management - Internal"
  }, {
    "id": 6322,
    "description": "Occupational Health & Safety"
  }, {
    "id": 6323,
    "description": "Organisational Development"
  }, {
    "id": 6324,
    "description": "Recruitment - Agency"
  }, {
    "id": 6325,
    "description": "Recruitment - Internal"
  }, {
    "id": 6326,
    "description": "Remuneration & Benefits"
  }, {
    "id": 6327,
    "description": "Training & Development"
  }, {
    "id": 6328,
    "description": "Other"
  }]
}, {
  "id": 6281,
  "description": "Information & Communication Technology",
  "subClassifications": [{
    "id": 6282,
    "description": "Architects"
  }, {
    "id": 6283,
    "description": "Business/Systems Analysts"
  }, {
    "id": 6284,
    "description": "Computer Operators"
  }, {
    "id": 6285,
    "description": "Consultants"
  }, {
    "id": 6286,
    "description": "Database Development & Administration"
  }, {
    "id": 6287,
    "description": "Developers/Programmers"
  }, {
    "id": 6288,
    "description": "Engineering - Hardware"
  }, {
    "id": 6289,
    "description": "Engineering - Network"
  }, {
    "id": 6290,
    "description": "Engineering - Software"
  }, {
    "id": 6291,
    "description": "Help Desk & IT Support"
  }, {
    "id": 6292,
    "description": "Management"
  }, {
    "id": 6293,
    "description": "Networks & Systems Administration"
  }, {
    "id": 6294,
    "description": "Product Management & Development"
  }, {
    "id": 6295,
    "description": "Programme & Project Management"
  }, {
    "id": 6296,
    "description": "Sales - Pre & Post"
  }, {
    "id": 6297,
    "description": "Security"
  }, {
    "id": 6298,
    "description": "Team Leaders"
  }, {
    "id": 6299,
    "description": "Technical Writing"
  }, {
    "id": 6300,
    "description": "Telecommunications"
  }, {
    "id": 6301,
    "description": "Testing & Quality Assurance"
  }, {
    "id": 6302,
    "description": "Web Development & Production"
  }, {
    "id": 6303,
    "description": "Other"
  }]
}, {
  "id": 1214,
  "description": "Insurance & Superannuation",
  "subClassifications": [{
    "id": 6275,
    "description": "Actuarial"
  }, {
    "id": 6276,
    "description": "Assessment"
  }, {
    "id": 6277,
    "description": "Brokerage"
  }, {
    "id": 1350,
    "description": "Claims"
  }, {
    "id": 6278,
    "description": "Fund Administration"
  }, {
    "id": 6279,
    "description": "Management"
  }, {
    "id": 1499,
    "description": "Risk Consulting"
  }, {
    "id": 1524,
    "description": "Superannuation"
  }, {
    "id": 1544,
    "description": "Underwriting"
  }, {
    "id": 1553,
    "description": "Workers' Compensation"
  }, {
    "id": 6280,
    "description": "Other"
  }]
}, {
  "id": 1216,
  "description": "Legal",
  "subClassifications": [{
    "id": 6188,
    "description": "Banking & Finance Law"
  }, {
    "id": 6190,
    "description": "Construction Law"
  }, {
    "id": 6191,
    "description": "Corporate & Commercial Law"
  }, {
    "id": 6189,
    "description": "Criminal & Civil Law"
  }, {
    "id": 6192,
    "description": "Environment & Planning Law"
  }, {
    "id": 6193,
    "description": "Family Law"
  }, {
    "id": 6194,
    "description": "Generalists - In-house"
  }, {
    "id": 6195,
    "description": "Generalists - Law Firm"
  }, {
    "id": 6196,
    "description": "Industrial Relations & Employment Law"
  }, {
    "id": 6197,
    "description": "Insurance & Superannuation Law"
  }, {
    "id": 6198,
    "description": "Intellectual Property Law"
  }, {
    "id": 1429,
    "description": "Law Clerks & Paralegals"
  }, {
    "id": 6199,
    "description": "Legal Practice Management"
  }, {
    "id": 1431,
    "description": "Legal Secretaries"
  }, {
    "id": 6200,
    "description": "Litigation & Dispute Resolution"
  }, {
    "id": 6201,
    "description": "Personal Injury Law"
  }, {
    "id": 6202,
    "description": "Property Law"
  }, {
    "id": 6203,
    "description": "Tax Law"
  }, {
    "id": 6204,
    "description": "Other"
  }]
}, {
  "id": 6092,
  "description": "Manufacturing, Transport & Logistics",
  "subClassifications": [{
    "id": 6095,
    "description": "Analysis & Reporting"
  }, {
    "id": 6093,
    "description": "Assembly & Process Work"
  }, {
    "id": 6094,
    "description": "Aviation Services"
  }, {
    "id": 6096,
    "description": "Couriers, Drivers & Postal Services"
  }, {
    "id": 6097,
    "description": "Fleet Management"
  }, {
    "id": 6098,
    "description": "Freight/Cargo Forwarding"
  }, {
    "id": 6099,
    "description": "Import/Export & Customs"
  }, {
    "id": 6101,
    "description": "Machine Operators"
  }, {
    "id": 6102,
    "description": "Management"
  }, {
    "id": 6104,
    "description": "Pattern Makers & Garment Technicians"
  }, {
    "id": 6105,
    "description": "Pickers & Packers"
  }, {
    "id": 6103,
    "description": "Production, Planning & Scheduling"
  }, {
    "id": 6100,
    "description": "Public Transport & Taxi Services"
  }, {
    "id": 6109,
    "description": "Purchasing, Procurement & Inventory"
  }, {
    "id": 6106,
    "description": "Quality Assurance & Control"
  }, {
    "id": 6110,
    "description": "Rail & Maritime Transport"
  }, {
    "id": 6111,
    "description": "Road Transport"
  }, {
    "id": 6107,
    "description": "Team Leaders/Supervisors"
  }, {
    "id": 6108,
    "description": "Warehousing, Storage & Distribution"
  }, {
    "id": 6112,
    "description": "Other"
  }]
}, {
  "id": 6008,
  "description": "Marketing & Communications",
  "subClassifications": [{
    "id": 6009,
    "description": "Brand Management"
  }, {
    "id": 6010,
    "description": "Digital & Search Marketing"
  }, {
    "id": 6011,
    "description": "Direct Marketing & CRM"
  }, {
    "id": 6012,
    "description": "Event Management"
  }, {
    "id": 6013,
    "description": "Internal Communications"
  }, {
    "id": 6017,
    "description": "Management"
  }, {
    "id": 6014,
    "description": "Market Research & Analysis"
  }, {
    "id": 6015,
    "description": "Marketing Assistants/Coordinators"
  }, {
    "id": 6016,
    "description": "Marketing Communications"
  }, {
    "id": 6018,
    "description": "Product Management & Development"
  }, {
    "id": 6019,
    "description": "Public Relations & Corporate Affairs"
  }, {
    "id": 6020,
    "description": "Trade Marketing"
  }, {
    "id": 6021,
    "description": "Other"
  }]
}, {
  "id": 6058,
  "description": "Mining, Resources & Energy",
  "subClassifications": [{
    "id": 6059,
    "description": "Analysis & Reporting"
  }, {
    "id": 6060,
    "description": "Health, Safety & Environment"
  }, {
    "id": 6061,
    "description": "Management"
  }, {
    "id": 6062,
    "description": "Mining - Drill & Blast"
  }, {
    "id": 6063,
    "description": "Mining - Engineering & Maintenance"
  }, {
    "id": 6064,
    "description": "Mining - Exploration & Geoscience"
  }, {
    "id": 6066,
    "description": "Mining - Operations"
  }, {
    "id": 6065,
    "description": "Mining - Processing"
  }, {
    "id": 6073,
    "description": "Natural Resources & Water"
  }, {
    "id": 6067,
    "description": "Oil & Gas - Drilling"
  }, {
    "id": 6068,
    "description": "Oil & Gas - Engineering & Maintenance"
  }, {
    "id": 6069,
    "description": "Oil & Gas - Exploration & Geoscience"
  }, {
    "id": 6071,
    "description": "Oil & Gas - Operations"
  }, {
    "id": 6070,
    "description": "Oil & Gas - Production & Refinement"
  }, {
    "id": 6072,
    "description": "Power Generation & Distribution"
  }, {
    "id": 6074,
    "description": "Surveying"
  }, {
    "id": 6075,
    "description": "Other"
  }]
}, {
  "id": 1220,
  "description": "Real Estate & Property",
  "subClassifications": [{
    "id": 6371,
    "description": "Administration"
  }, {
    "id": 6001,
    "description": "Analysts"
  }, {
    "id": 6002,
    "description": "Body Corporate & Facilities Management"
  }, {
    "id": 6003,
    "description": "Commercial Sales, Leasing & Property Mgmt"
  }, {
    "id": 6004,
    "description": "Residential Leasing & Property Management"
  }, {
    "id": 6005,
    "description": "Residential Sales"
  }, {
    "id": 6006,
    "description": "Retail & Property Development"
  }, {
    "id": 1546,
    "description": "Valuation"
  }, {
    "id": 6007,
    "description": "Other"
  }]
}, {
  "id": 6043,
  "description": "Retail & Consumer Products",
  "subClassifications": [{
    "id": 6044,
    "description": "Buying"
  }, {
    "id": 6045,
    "description": "Management - Area/Multi-site"
  }, {
    "id": 6046,
    "description": "Management - Department/Assistant"
  }, {
    "id": 6047,
    "description": "Management - Store"
  }, {
    "id": 6048,
    "description": "Merchandisers"
  }, {
    "id": 6049,
    "description": "Planning"
  }, {
    "id": 6050,
    "description": "Retail Assistants"
  }, {
    "id": 6051,
    "description": "Other"
  }]
}, {
  "id": 6362,
  "description": "Sales",
  "subClassifications": [{
    "id": 6363,
    "description": "Account & Relationship Management"
  }, {
    "id": 6364,
    "description": "Analysis & Reporting"
  }, {
    "id": 6366,
    "description": "Management"
  }, {
    "id": 6365,
    "description": "New Business Development"
  }, {
    "id": 6367,
    "description": "Sales Coordinators"
  }, {
    "id": 6368,
    "description": "Sales Representatives/Consultants"
  }, {
    "id": 6369,
    "description": "Other"
  }]
}, {
  "id": 1223,
  "description": "Science & Technology",
  "subClassifications": [{
    "id": 6215,
    "description": "Biological & Biomedical Sciences"
  }, {
    "id": 6216,
    "description": "Biotechnology & Genetics"
  }, {
    "id": 6217,
    "description": "Chemistry & Physics"
  }, {
    "id": 6218,
    "description": "Environmental, Earth & Geosciences"
  }, {
    "id": 6219,
    "description": "Food Technology & Safety"
  }, {
    "id": 6220,
    "description": "Laboratory & Technical Services"
  }, {
    "id": 6221,
    "description": "Materials Sciences"
  }, {
    "id": 6222,
    "description": "Mathematics, Statistics & Information Sciences"
  }, {
    "id": 6223,
    "description": "Modelling & Simulation"
  }, {
    "id": 6224,
    "description": "Quality Assurance & Control"
  }, {
    "id": 6225,
    "description": "Other"
  }]
}, {
  "id": 6261,
  "description": "Self Employment",
  "subClassifications": [{
    "id": 6262,
    "description": "Self Employment"
  }]
}, {
  "id": 6246,
  "description": "Sport & Recreation",
  "subClassifications": [{
    "id": 6247,
    "description": "Coaching & Instruction"
  }, {
    "id": 6248,
    "description": "Fitness & Personal Training"
  }, {
    "id": 6249,
    "description": "Management"
  }, {
    "id": 6250,
    "description": "Other"
  }]
}, {
  "id": 1225,
  "description": "Trades & Services",
  "subClassifications": [{
    "id": 1313,
    "description": "Air Conditioning & Refrigeration"
  }, {
    "id": 1328,
    "description": "Automotive Trades"
  }, {
    "id": 6226,
    "description": "Bakers & Pastry Chefs"
  }, {
    "id": 6227,
    "description": "Building Trades"
  }, {
    "id": 6228,
    "description": "Butchers"
  }, {
    "id": 1345,
    "description": "Carpentry & Cabinet Making"
  }, {
    "id": 6229,
    "description": "Cleaning Services"
  }, {
    "id": 6230,
    "description": "Electricians"
  }, {
    "id": 6231,
    "description": "Fitters, Turners & Machinists"
  }, {
    "id": 6232,
    "description": "Floristry"
  }, {
    "id": 1406,
    "description": "Gardening & Landscaping"
  }, {
    "id": 6233,
    "description": "Hair & Beauty Services"
  }, {
    "id": 6234,
    "description": "Labourers"
  }, {
    "id": 6235,
    "description": "Locksmiths"
  }, {
    "id": 6236,
    "description": "Maintenance & Handyperson Services"
  }, {
    "id": 6237,
    "description": "Nannies & Babysitters"
  }, {
    "id": 6238,
    "description": "Painters & Sign Writers"
  }, {
    "id": 6240,
    "description": "Plumbers"
  }, {
    "id": 6239,
    "description": "Printing & Publishing Services"
  }, {
    "id": 6241,
    "description": "Security Services"
  }, {
    "id": 6242,
    "description": "Tailors & Dressmakers"
  }, {
    "id": 6243,
    "description": "Technicians"
  }, {
    "id": 6244,
    "description": "Welders & Boilermakers"
  }, {
    "id": 6245,
    "description": "Other"
  }]
}];


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-classifications-hierarchy/build/classifications-hierachy.js
 ** module id = 448
 ** module chunks = 0
 **/